import React from 'react';
import InlineMessage from '@ingka/inline-message';
import infoIcon from '@ingka/ssr-icon/paths/information-circle';
import warningIcon from '@ingka/ssr-icon/paths/warning-triangle';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import platform from '../../util/platform';
import { translate } from '../../services/L10n';
import { closeSupplyBanner } from '../../state/popups';
import {
  selectIsSupplyBannedEnabled,
  selectSupplyBannerMessageType,
  selectSupplyBannerLinkURL,
} from '../../state/dexfSettings/dexfSettingsSelectors';
import styles from './SupplyBanner.module.less';
import { t } from '../../translations';

class SupplyBanner extends React.Component {
  static propTypes = {
    userAgent: PropTypes.object.isRequired,
    supplyBannerClosed: PropTypes.bool.isRequired,
    closeSupplyBanner: PropTypes.func.isRequired,
    isSupplyBannerEnabled: PropTypes.bool.isRequired,
    supplyBannerMessageType: PropTypes.string.isRequired,
    supplyBannerLinkURL: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.events = {
      onClose: () => this.props.closeSupplyBanner(),
    };
    this.state = {};
  }

  getTitle = () =>
    platform.isKiosk
      ? translate(t.PLANNER_BANNER_MESSAGE_TITLE_KIOSK)
      : translate(t.PLANNER_BANNER_MESSAGE_TITLE);

  getBody = () => {
    const isMobile = this.props.userAgent.isMobile;
    const isKiosk = platform.isKiosk;

    const bodyTextDesktop = translate(t.PLANNER_BANNER_MESSAGE_BODY);
    const bodyTextKiosk = translate(t.PLANNER_BANNER_MESSAGE_BODY_KIOSK);

    const link = {
      href: this.props.supplyBannerLinkURL,
      label: this.props.supplyBannerLinkURL
        ? translate(t.PLANNER_BANNER_MESSAGE_LINK_TEXT)
        : undefined,
    };

    if (isMobile) return { text: null, link };
    else if (isKiosk) return { text: bodyTextKiosk, link: undefined };
    else return { text: bodyTextDesktop, link };
  };

  getLayout = () => {
    switch (this.props.supplyBannerMessageType) {
      case 'Cautionary':
        return { variant: 'cautionary', icon: warningIcon };
      case 'Information':
      default:
        return { variant: 'informative', icon: infoIcon };
    }
  };

  shouldBannerBeDisplayed = () => {
    const { isSupplyBannerEnabled } = this.props;
    const bannerClosed = this.props.supplyBannerClosed;

    return isSupplyBannerEnabled && !bannerClosed;
  };
  render() {
    return this.shouldBannerBeDisplayed() ? (
      <InlineMessage
        className={styles.supplyBannerInlineMessage}
        dismissable
        variant={this.getLayout().variant}
        ssrIcon={this.getLayout().icon}
        title={this.getTitle()}
        body={this.getBody().text}
        link={this.getBody().link?.href}
        linkLabel={this.getBody().link?.label}
        newWindow
        onDismissClick={() => this.events.onClose()}
      />
    ) : null;
  }
}
export default connect(
  state => ({
    userAgent: state.userAgent,
    supplyBannerClosed: state.popups.supplyBannerClosed,
    isSupplyBannerEnabled: selectIsSupplyBannedEnabled(state),
    supplyBannerMessageType: selectSupplyBannerMessageType(state),
    supplyBannerLinkURL: selectSupplyBannerLinkURL(state),
  }),
  dispatch => ({
    closeSupplyBanner: () => dispatch(closeSupplyBanner()),
  })
)(SupplyBanner);
